import { lazy, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { profileTypes } from '../config/constants/userConstants';

const CustomViewsReports = lazy(() => import('../views/CustomViewsReports/CustomViewsReports'));

export function useReportRoutes() {
  const { currentUserProfile, customViewsReports } = useSelector((state) => ({
    currentUserProfile: state.auth.currentUser?.profile?.idProfile,
    customViewsReports: state.customViewsReports.data.customViewsReports,
  }));

  const reportRoutes = useMemo(() => {
    const customRoutes = customViewsReports.map((item) => ({
      path: item.path,
      name: item.title,
      icon: item.icon || 'file-text',
      profiles: [profileTypes.ADMIN.id, profileTypes.OPERATOR.id, profileTypes.MASTER.id],
      component: CustomViewsReports,
    }));
    return customRoutes;
  }, [currentUserProfile, customViewsReports]);

  return reportRoutes;
}
